module.exports.default = [
    {
        "name": "Basque",
        "code": "eu",
        "translations": 54,
        "percentage": 28.88,
        "updated": "2021-11-09T07:22:35+0000"
    },
    {
        "name": "Bulgarian",
        "code": "bg",
        "translations": 26,
        "percentage": 13.9,
        "updated": "2020-06-04T07:40:46+0000"
    },
    {
        "name": "Catalan",
        "code": "ca",
        "translations": 54,
        "percentage": 28.88,
        "updated": "2021-11-09T07:22:46+0000"
    },
    {
        "name": "Danish",
        "code": "da",
        "translations": 26,
        "percentage": 13.9,
        "updated": "2020-06-04T07:41:35+0000"
    },
    {
        "name": "Dutch",
        "code": "nl",
        "translations": 105,
        "percentage": 56.15,
        "updated": "2021-05-23T09:52:47+0000"
    },
    {
        "name": "English",
        "code": "en",
        "translations": 187,
        "percentage": 100,
        "updated": "2026-08-10T10:32:17+0000"
    },
    {
        "name": "Finnish",
        "code": "fi",
        "translations": 179,
        "percentage": 95.72,
        "updated": "2026-08-10T10:32:39+0000"
    },
    {
        "name": "French",
        "code": "fr",
        "translations": 179,
        "percentage": 95.72,
        "updated": "2026-08-10T10:33:02+0000"
    },
    {
        "name": "Galician",
        "code": "gl",
        "translations": 54,
        "percentage": 28.88,
        "updated": "2021-11-09T07:23:00+0000"
    },
    {
        "name": "German",
        "code": "de",
        "translations": 179,
        "percentage": 95.72,
        "updated": "2026-08-10T10:33:25+0000"
    },
    {
        "name": "Greek",
        "code": "el",
        "translations": 161,
        "percentage": 86.1,
        "updated": "2025-12-01T10:21:57+0000"
    },
    {
        "name": "Hebrew",
        "code": "he",
        "translations": 161,
        "percentage": 86.1,
        "updated": "2025-12-01T10:12:41+0000"
    },
    {
        "name": "Italian",
        "code": "it",
        "translations": 179,
        "percentage": 95.72,
        "updated": "2026-08-10T10:33:47+0000"
    },
    {
        "name": "Kinyarwanda",
        "code": "rw",
        "translations": 148,
        "percentage": 79.14,
        "updated": "2024-03-18T13:50:42+0000"
    },
    {
        "name": "Polish",
        "code": "pl",
        "translations": 27,
        "percentage": 14.44,
        "updated": "2024-03-18T13:51:33+0000"
    },
    {
        "name": "Portuguese",
        "code": "pt",
        "translations": 179,
        "percentage": 95.72,
        "updated": "2026-08-10T10:34:10+0000"
    },
    {
        "name": "Portuguese (BR)",
        "code": "pt-br",
        "translations": 179,
        "percentage": 95.72,
        "updated": "2026-08-10T10:34:33+0000"
    },
    {
        "name": "Romanian",
        "code": "ro",
        "translations": 26,
        "percentage": 13.9,
        "updated": "2020-06-04T07:56:28+0000"
    },
    {
        "name": "Russian",
        "code": "ru",
        "translations": 26,
        "percentage": 13.9,
        "updated": "2020-06-04T07:57:17+0000"
    },
    {
        "name": "Spanish",
        "code": "es",
        "translations": 179,
        "percentage": 95.72,
        "updated": "2026-08-10T10:34:55+0000"
    },
    {
        "name": "Swedish",
        "code": "sv",
        "translations": 27,
        "percentage": 14.44,
        "updated": "2020-06-04T07:43:55+0000"
    },
    {
        "name": "Thai",
        "code": "th",
        "translations": 26,
        "percentage": 13.9,
        "updated": "2020-06-04T07:57:53+0000"
    },
    {
        "name": "Turkish",
        "code": "tr",
        "translations": 27,
        "percentage": 14.44,
        "updated": "2020-06-04T07:23:37+0000"
    },
    {
        "name": "Vietnamese",
        "code": "vi",
        "translations": 26,
        "percentage": 13.9,
        "updated": "2020-06-04T07:54:35+0000"
    }
];
	